module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_danone_03.7857b7a7.jpg";